import { withMetadata } from '../min/metadata'

import _getNumberType from '../es6/getNumberType'

export function getNumberType() {
	return withMetadata(_getNumberType, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/getNumberType.js
// module id = DdaF
// module chunks = 0 1